export default () => ({
  title: "",
  sections:[],
  sectionsForCurrentUser:[],
  section:null,
  sectionToEdit: '',
  status: '',
  total: "",
});
